import { render, staticRenderFns } from "./PermissionTable.vue?vue&type=template&id=39c7b9ee&"
import script from "./PermissionTable.vue?vue&type=script&lang=js&"
export * from "./PermissionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports